import { SvgIcon, SvgIconProps } from '@mui/material';

export default function ApplicationPaymentsIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props} viewBox="0 0 48 63">
      <g fill="none">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10 0C4.47715 0 0 4.47715 0 10V37.5V38V62.5L8.29838 47.8558C8.8514 47.9506 9.41993 48 10 48H38C43.5228 48 48 43.5229 48 38V10C48 4.47715 43.5229 0 38 0H10Z"
          fill="#E27816"
        />
        <g fill="none" transform="translate(9 9) scale(0.8)">
          <path
            d="M7.57718 14.5247L6.40568 10.8842C6.02522 9.70211 6.67441 8.43527 7.85618 8.05372L28.7152 1.33522C29.8977 0.95489 31.1648 1.60486 31.5457 2.78722L34.6657 12.4712C34.8488 13.0393 34.7987 13.6569 34.5263 14.188C34.254 14.7191 33.7818 15.1203 33.2137 15.3032L25.9762 17.6342"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M25.9766 28.0244V31.8809C25.9742 32.6507 25.6661 33.388 25.1201 33.9307C24.5741 34.4733 23.8349 34.7768 23.0651 34.7744H4.13806C3.36827 34.7768 2.62906 34.4733 2.08304 33.9307C1.53703 33.388 1.22895 32.6507 1.22656 31.8809V17.4164C1.22895 16.6468 1.53708 15.9096 2.08314 15.3672C2.62919 14.8248 3.36841 14.5216 4.13806 14.5244H23.0651C23.8347 14.5216 24.5739 14.8248 25.12 15.3672C25.666 15.9096 25.9742 16.6468 25.9766 17.4164V21.2744"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M6.85156 14.5469V34.7744"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M21.2156 21.2744C19.4247 21.3491 18.0316 22.8583 18.1001 24.6494C18.0316 26.4406 19.4247 27.9497 21.2156 28.0244H26.6681C27.563 27.9863 28.2589 27.232 28.2251 26.3369V22.9619C28.2597 22.0665 27.5634 21.3118 26.6681 21.2744H21.2156Z"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M24.3398 23.9404C24.6505 23.9404 24.9023 24.1923 24.9023 24.5029C24.9023 24.8136 24.6505 25.0654 24.3398 25.0654C24.0292 25.0654 23.7773 24.8136 23.7773 24.5029C23.7773 24.1923 24.0292 23.9404 24.3398 23.9404"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M18.3438 11.2507C18.7629 10.4245 19.6456 9.93961 20.5678 10.0291C21.4899 10.1187 22.2629 10.7643 22.5152 11.6557"
            stroke="#fff"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
      </g>
    </SvgIcon>
  );
}
